const _ = require('lodash'), $ = require('jquery'); //, transition = require('../../../common/components/transition/transition-events.js');

const openCartMapper = require('../globalheader/atmmapper/open-cart-mapper'); //View cart analytics

function setRightPanelSrText(service) {
    service.czToggleSrText = service.panels.right ? 'Collapse collection zone' : 'Expand collection zone';
}

function setFocus(panel) {
    const self = this;

    // Moves focus to panel, when it opens
    if (self.panels[panel]) {
        // todo: fix this during a11y cleanup
        this._$timeout(() => {
            self._moveFocus(`#${panel}-panel`);
        }, 1000);
    }
}

function routeDefaultsIndex(el) {
    const self = el;
    const arrayIndex = _.findIndex(self.defaultPanelStateForRoute, function (chr) {
        return chr.name === self._state.current.name;
    });
    return arrayIndex;
}

function _initPanelsForRoute(routeArrayIndex, self) {
    let large = {}, medSmall = {};
    const routeDefaults = self.defaultPanelStateForRoute[routeArrayIndex];
    if (routeDefaults.large) {
        large = routeDefaults.large;
    }
    if (routeDefaults.medSmall) {
        medSmall = routeDefaults.medSmall;
    }

    if (self._breakpointsService.isMediumFormat() || self._breakpointsService.isSmallFormat()) {
        if (medSmall.forceCloseLeft) {
            self.panels.left = false;
        } else {
            self.panels.left = true;
        }
        self.panels.right = medSmall.right || false;
        self.updateCenterPanel(self.animationDelay, self.panels.left, self.panels.right, true);
    } else {
        if (large.forceCloseLeft) {
            self.panels.left = false;
        } else {
            self.panels.left = true;
        }
        self.panels.right = large.right || false;
        self.updateCenterPanel(0, self.panels.left, self.panels.right, true);
    }
}

function _init() {
    const arrayIndex = routeDefaultsIndex(this);
    if (arrayIndex > -1) {
        _initPanelsForRoute(arrayIndex, this);
    } else if (this._breakpointsService.isMediumFormat() || this._breakpointsService.isSmallFormat()) {
        this.panels.left = false;
        this.panels.right = false;
        this.updateCenterPanel(this.animationDelay, this.panels.left, this.panels.right, true);
    } else {
        this.panels.left = false;
        this.panels.right = false;
        this.updateCenterPanel(0, this.panels.left, this.panels.right, true);
    }
}

const ANIMATION_DELAY = 0;

function ShopPageStateService($timeout, breakpointsService, $state, $rootScope, $document, moveFocus, userPreferenceService, shopperService, animationsService, memoScroll, atm, $injector) {
    this.isGlobalHeaderExpanded = true;
    this._$timeout = $timeout;
    this._document = $document;
    this._breakpointsService = breakpointsService;
    this.animationDelay = 0;
    this.invokeApply = false;
    this._state = $state;
    this.smallFormatMenuOpen = false;
    this.isPanelsAnimating = false;
    this.$rootScope = $rootScope;
    this._moveFocus = moveFocus;
    this.shopperService = shopperService;
    this._animationsService = animationsService;
    this._memoScroll = memoScroll;
    this.atmService = atm;
    this.injector = $injector;

    this.centerPanelSelector = '.main-content-container';

    this._hiddenClass = {
        leftPanel: 'leftPanel-ishidden',
        rightPanel: 'rightPanel-ishidden'
    };

    this.initSidePanels = _.debounce(_init.bind(this), 100);

    this.panels = {
        right: true,
        left: true
    };

    this.panelAction = {
        open: true,
        close: false
    };

    this.lfhiddenLeftPanelState = [
        'root',
        'shop',
        'shop.browse',
        'shop.404error',
        'shop.500error',
        'shop.403error',
        'checkout.confirmation',
        'shop.locator',
        'shop.list.pastordershops',
        'shop.unsubscribeedm',
        'shop.unsubscribeedm?shopperid&checksum',
        'shop.unsubscribeedm?shopperid&checksum&documentid',
        'shop.authentication.signup',
        'shop.partner',
        'shop.partnerbranch',
        'shop.conveniencepack',
        'shop.locator.store',
        'shop.myaccount',
        'shop.myaccount.myprofile',
        'shop.myaccount.orderhistory',
        'shop.persistentlogin',
        'shop.authentication.login',
        'shop.search',
        'shop.search.products',
        'shop.search.products.category',
        'shop.search.specials',
        'shop.search.specials.category',
        'shop.search.zero-result',
        'shop.search.external-result'
    ];

    this.sfhiddenLeftPanelState = [
        'checkout.confirmation'
    ];

    this.disabledPanel = {
        right: false,
        left: false
    };

    this.defaultPanelStateForRoute = [];

    const self = this;

    $rootScope.$on('logout:start', function () {
        userPreferenceService.saveRightPanelState(self.shopperService.Id, self.panels.right);
    });

    $rootScope.$on('$stateChangeStart', self._memoScroll.forgetScrollPosition.bind(self._memoScroll, 'before'));

    animationsService.isAnimationsEnabled().then(function (enabled) {
        if (enabled) {
            self.animationDelay = ANIMATION_DELAY;
            self.invokeApply = true;
        }
    });

    setRightPanelSrText(this);
}

ShopPageStateService.prototype.triggerPanel = _.throttle(function (panel, isOpen, panelViewed) {
    if (this.panels[panel] !== isOpen) {
        this.togglePanel(panel);
        //Right panel is for opening the cart. Also trigger add to cart for opening panel only
        if (panel === 'right' && isOpen && panelViewed) {
            this.atmService.push(this.injector.get('TrolleyService'), openCartMapper, false, panelViewed);
        }
    }
}, ANIMATION_DELAY);

ShopPageStateService.prototype.hideStackChat = function () {
    $('#web-messenger-container').attr('style', 'display:none');
    $('.proactive-container').attr('style', 'display:none');
};

ShopPageStateService.prototype.showStackChat = function () {
    $('#web-messenger-container').attr('style', 'display:block');
    $('.proactive-container').attr('style', 'display:block');
};

ShopPageStateService.prototype.togglePanel = _.throttle(function (panel) {
    if (this._breakpointsService.isMediumFormat() && !this.disabledPanel.left || this._breakpointsService.isSmallFormat() && !this.disabledPanel.left) {
        if (panel === 'left' && !this.panels[panel]) {
            this.panels.left = true;
            this.panels.right = false;
            this.updateCenterPanel(0, this.panels.left, this.panels.right);
            setRightPanelSrText(this);

            if (this._breakpointsService.isInSmallFormat) {
                this._$timeout(this._memoScroll.restoreScrollPosition.bind(this._memoScroll, 'before'), 0, false);
            }
            this.hideStackChat();
            return;
        } else if (panel === 'right' && !this.panels[panel]) {
            if (this._breakpointsService.isInSmallFormat) {
                this._memoScroll.rememberScrollPosition('before');
            }

            this.panels.left = false;
            this.panels.right = true;
            this.updateCenterPanel(0, this.panels.left, this.panels.right);
            setRightPanelSrText(this);
            this.hideStackChat();
            return;
        }
    }
    this.panels[panel] = !this.panels[panel];
    if (!this.panels[panel]) {
        this.updateCenterPanel(this.animationDelay, this.panels.left, this.panels.right);
    } else {
        this.updateCenterPanel(0, this.panels.left, this.panels.right);
    }
    setRightPanelSrText(this);
    setFocus.call(this, panel);
    this.showStackChat();
}, ANIMATION_DELAY);

ShopPageStateService.prototype.reset = function () {
    _init.call(this);
};

ShopPageStateService.prototype.changeStateOnToggle = function (panel, onAction, fromState, toState, toStateParameters) {
    const self = this;
    if (self._state.is(fromState) && self.panelAction[onAction] === self.panels[panel]) {
        self._$timeout(function () {
            self._state.transitionTo(toState, toStateParameters);
        }, self.animationDelay, self.invokeApply);
    }
};

ShopPageStateService.prototype.closeLeftPanel = function () {
    const self = this;
    const centerPanel = $(self.centerPanelSelector);
    this._$timeout(function () {
        centerPanel.toggleClass(self._hiddenClass.leftPanel, true);
    }, self.animationDelay, self.invokeApply);
};

const broadCastWidthUpdateStart = _.debounce(function ($rootScope) {
    $rootScope.$broadcast('centerPanelWidth:update:start');
}, 100);

ShopPageStateService.prototype.updateCenterPanel = function (delay, isLeftPanelOpen, isRightPanelOpen, shouldNotBroadcast) {
    const self = this;
    const centerPanel = $(self.centerPanelSelector);

    if (!shouldNotBroadcast) {
        broadCastWidthUpdateStart(self.$rootScope);
    }

    self._animationsService.isAnimationsEnabled().then(function (enabled) {
        if (enabled) {
            self._$timeout(function () {
                if (!self.disabledPanel.left) {
                    centerPanel.toggleClass(self._hiddenClass.leftPanel, !isLeftPanelOpen);
                }
                centerPanel.toggleClass(self._hiddenClass.rightPanel, !isRightPanelOpen);

                setTimeout(function () {
                    $(self.centerPanelSelector).addClass('animation-ended');
                    if (!shouldNotBroadcast) {
                        self.$rootScope.$broadcast('centerPanelWidth:update:end');
                    }
                }, 1000);
            }, delay);
        } else {
            if (!self.disabledPanel.left) {
                centerPanel.toggleClass(self._hiddenClass.leftPanel, !isLeftPanelOpen);
            }
            centerPanel.toggleClass(self._hiddenClass.rightPanel, !isRightPanelOpen);

            setTimeout(function () {
            $(self.centerPanelSelector).addClass('animation-ended');
            if (!shouldNotBroadcast) {
                self.$rootScope.$broadcast('centerPanelWidth:update:end');
            }
            }, 1000);
        }
    });


};

ShopPageStateService.prototype.resetCenterPanelScroll = function () {
    const el = this._breakpointsService.isInSmallFormat
        ? this._document
        : $(this.centerPanelSelector + ' > .hideScroll-wrapper');
    el.scrollTop(0);
    scrollTo(0, -1);
};

module.exports = ShopPageStateService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoppagestate/shoppagestate-service.js
 **/